<template>
    <div>
        <p class="total-palm">(n = {{ yearlyYieldChartData.totalPalmsInvolved }})</p>
        <table class="table yield-year-mean-table">
            <tr>
                <td />
                <td v-for="(year, y_idx) in yearlyYieldChartData.yearData" :key="'year' + y_idx" class="yield-year-title">
                    <span>{{ year[0] }}</span>
                    <span>{{ getNCount(y_idx) }}</span>
                </td>
            </tr>
            <tr>
                <td class="yield-year-left-title">FFB(kg/p/yr)</td>
                <td v-for="(ffn, ffb_idx) in yearlyYieldChartData.ffbData" :key="'ffn' + ffb_idx">{{ $_roundOfDecimal(ffn[0], 2) || '-' }}</td>
            </tr>
            <tr>
                <td class="yield-year-left-title">BNO(no.)</td>
                <td v-for="(bno, bno_idx) in yearlyYieldChartData.bnoData" :key="'bno' + bno_idx">{{ $_roundOfDecimal(bno[0], 2) || '-' }}</td>
            </tr>
            <tr>
                <td class="yield-year-left-title">ABW(kg/p/yr)</td>
                <td v-for="(abw, abw_idx) in yearlyYieldChartData.abwData" :key="'abw' + abw_idx">{{ $_roundOfDecimal(abw[0], 2) || '-' }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        yearlyYieldChartData: {
            type: Object
        }
    },
    methods: {
        getNCount(idx) {
            return `n=(${this.yearlyYieldChartData.palmCountEachYear[idx][0]})`;
        }
    },
};
</script>

<style scoped>
.yield-year-mean-table {
    margin-top: 12px;
}
.yield-year-mean-table td{
    text-align: center;
    padding: 4px;
}
.yield-year-title span{
    display: inline-block;
}
.yield-year-title {
    font-weight: 700;
}
.yield-year-left-title {
    text-align: left !important;
    font-weight: 700;
    width: 140px;
}
.total-palm {
    margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Chart/YieldYearMeanTable.vue